<template>
    <div class="flags">
      <img
        v-for="(flag, index) in flags"
        :class="{ active: flag === selectedLanguage }"
        :key="index"
        :src="getFlagImg(flag)"
        @click="selectLanguage(flag)"/>
    </div>
  </template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'FlagsComponent',
    computed: {
        ...mapGetters(['flags', 'selectedLanguage'])
    },
    methods: {
        ...mapActions(['selectLanguage']),
        getFlagImg (flag) {
            return require(`@/assets/default/icons/flags/${flag}.png`)
        }
    }
}
</script>

  <style lang="less">
  .flags {
    display: table;
    margin: 15px 0 15px auto;
    img {
        width: 30px;
        &:nth-of-type(2) {
            margin: 0 15px;
        }
        padding-bottom: 3px;
        display: inline-block;
        border-bottom: solid 3px transparent;
        transition: all .25s linear;
        &.active {
            border-bottom: solid 3px var(--primaryColor);
        }
    }
  }
  </style>
